"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Types = exports.Sizes = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["children", "functional", "primary"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * // TODO: изменить использование на проектах на ButtonTs
 * @see https://leveltravel.atlassian.net/browse/LT-23586
 */
var Sizes = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny'
};
exports.Sizes = Sizes;
var Types = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit'
};
exports.Types = Types;
var SIZES = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny'
};
var TYPES = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit'
};
/**
 * @deprecated используй ButtonTs
 */

var Button = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Button, _React$PureComponent);

  var _super = _createSuper(Button);

  function Button() {
    (0, _classCallCheck2["default"])(this, Button);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isFunctional = _this$props.functional,
          isPrimary = _this$props.primary,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var button;

      if (isFunctional) {
        button = /*#__PURE__*/_react["default"].createElement(StyledFunctionalButton, null);
      } else if (isPrimary) {
        button = /*#__PURE__*/_react["default"].createElement(StyledPrimaryButton, null);
      } else {
        button = /*#__PURE__*/_react["default"].createElement(StyledButton, null);
      }

      return /*#__PURE__*/_react["default"].cloneElement(button, props, children);
    }
  }]);
  return Button;
}(_react["default"].PureComponent);

Button.propTypes = {
  autoFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  functional: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  primary: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(Object.values(SIZES)),
  type: _propTypes["default"].oneOf(Object.values(TYPES))
};
Button.defaultProps = {
  autoFocus: false,
  children: null,
  className: '',
  disabled: false,
  functional: false,
  onClick: Function.prototype,
  primary: false,
  size: SIZES.NORMAL,
  type: TYPES.BUTTON
};
Button.Sizes = SIZES;
Button.Types = TYPES;

var BasePropsStyle = _styledComponents["default"].button.withConfig({
  displayName: "Button__BasePropsStyle",
  componentId: "sc-2l34wi-0"
})(["&{cursor:pointer;font-family:inherit;", "}"], function (props) {
  return props.disabled && "\n      cursor: default;\n      user-select: none;\n    ";
});

var BaseStyle = (0, _styledComponents["default"])(BasePropsStyle).withConfig({
  displayName: "Button__BaseStyle",
  componentId: "sc-2l34wi-1"
})(["&:focus{outline:none;}border-radius:4px;padding:0 10px;", " ", " ", " ", " ", " ", ""], function (props) {
  return props.size && props.size !== SIZES.FLEX && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ";
}, function (props) {
  return (props.size === SIZES.FLEX || props.size === SIZES.NORMAL) && "\n    line-height: 16px;\n    padding-bottom: 7px;\n    padding-top: 7px;\n  ";
}, function (props) {
  return props.size === SIZES.FLEX && "\n    min-height: 43px;\n    width: initial;\n  ";
}, function (props) {
  return props.size === SIZES.LARGE && "\n    height: 48px;\n    width: 150px;\n  ";
}, function (props) {
  return props.size === SIZES.NORMAL && "\n    height: 43px;\n    width: 150px;\n  ";
}, function (props) {
  return props.size === SIZES.TINY && "\n    height: 34px;\n    max-width: 150px;\n  ";
});
var StyledButton = (0, _styledComponents["default"])(BaseStyle).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-2l34wi-2"
})(["border:1px solid #007aff;color:#007aff;", " ", ""], function (props) {
  return !(props.disabled || props.offHover) && "\n    :hover {\n      border-color: #179fe3;\n      color: #179fe3;\n    }\n  ";
}, function (props) {
  return props.disabled && "\n    border-color: #c2c5cc;\n    color: #c2c5cc;\n  ";
});
var StyledPrimaryButton = (0, _styledComponents["default"])(BaseStyle).withConfig({
  displayName: "Button__StyledPrimaryButton",
  componentId: "sc-2l34wi-3"
})(["", ";font-weight:700;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.elements.button.primary;
}, function (props) {
  return props.offHover && (0, _styledComponents.css)(["&,&:hover{box-shadow:0 2px 4px 0 rgba(0,0,0,0.1);border:solid 1px ", ";background:", ";}"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.cloudyBlue;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.white;
  });
});
var StyledFunctionalButton = (0, _styledComponents["default"])(BasePropsStyle).withConfig({
  displayName: "Button__StyledFunctionalButton",
  componentId: "sc-2l34wi-4"
})(["appearance:none;background-color:transparent;border:none;color:inherit;font:inherit;"]);
var _default = Button;
exports["default"] = _default;